// extracted by mini-css-extract-plugin
module.exports = {"container":"monday-date-picker_container__G0LZh"};